const basicResultMessage1 = {
  patternA: `いかがでしたか？<br>誰にでも長所があれば、短所もあります。そして自分にとっては短所だと思っている部分が、実は人からうらやましがられることも。<br>見方を変えれば、どちらにも転ぶんです。あなたの持って生まれた性質を活かして、幸せな人生を送るためにはどうすればいいのか？<br>もう少し占っていきますね。<br><br>次は、あなたが生まれ持った「宿命」と「運命の人」について、見ていきましょう。`,
  patternB: `いかがでしたか？<br>誰にでも長所があれば、短所もあります。そして自分にとっては短所だと思っている部分が、実は人からうらやましがられることも。<br>見方を変えれば、どちらにも転ぶんです。あなたの持って生まれた性質を活かして、幸せな人生を送るためにはどうすればいいのか？<br>もう少し占っていきますね。<br><br>次は、あなたに最も適している「仕事」、そして「運命の人」について、見ていきましょう。`,
}

export const patternA = {
  basicResult: {
    message1: basicResultMessage1.patternA,
  }
}

export const patternB = {
  basicResult: {
    message1: basicResultMessage1.patternB,
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/houen/testData/patterns/pattern20220403.js